<template>
  <div class="results">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>

      <div class="card">
        <p class="title">
          Scheduled Reminders
          <button
            class="btn round-btn img-btn"
            @click="$router.push(`/${source}s`)"
          >
            {{ source.toUpperCase() }}S
          </button>
        </p>
        <div class="action_btns">
          <div class="filter">
            <sub>Filter by Location</sub>
            <div class="inputs survey-forms">
              <div class="input full">
                <v-select
                  :options="locations"
                  label="name"
                  :clearable="false"
                  :reduce="l => l.id"
                  v-model="filter_values.location"
                  @input="moveToPage(0)"
                >
                  <template v-slot:option="option">
                    <div>
                      {{
                        `${option.name} - ${option.address_1}, ${option.city}, ${option.state}`
                      }}
                    </div>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="inputs survey-forms">
              <sub>Filter by Department</sub>
              <div class="input full">
                <v-select
                  :options="departments"
                  label="name"
                  :clearable="false"
                  :reduce="d => d.id"
                  v-model="filter_values.department"
                  @input="moveToPage(0)"
                >
                </v-select>
              </div>
            </div>
            <div class="inputs survey-forms">
              <button
                v-if="showClearBtn"
                @click="clearFilter"
                class="btn round-btn red"
              >
                Clear Filter
              </button>
            </div>
            <template v-if="selected_users.length">
              <div class="filters">
                <div class="filter">
                  <label>Email</label>
                  <div class="switch-holder">
                    <switches v-model="send_email"></switches>
                  </div>
                </div>
                <div class="filter">
                  <label>Phone</label>
                  <div class="switch-holder">
                    <switches v-model="send_text"></switches>
                  </div>
                </div>

                <button
                  @click="clearScheduledReminders"
                  class="btn round-btn red"
                >
                  Clear Scheduled Reminders
                </button>

                <button
                  @click="initScheduledpopup(false)"
                  :style="button_valid"
                  :disabled="!delivery_types.length"
                  class="btn dark round-btn"
                >
                  Scheduled Send
                </button>
              </div>
            </template>
          </div>
           <button
            @click="clearAllScheduledReminders"
            class="btn round-btn red"
          >Clear All Scheduled Reminders</button>
        </div>

        <div class="table-holder">
          <table>
            <thead>
              <tr>
                <th>Select All <input type="checkbox" ref="selectAll" @input="selectAll" /></th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Department</th>
                <th>Location</th>
                <th>Reminder Method</th>
                <th>Edit Reminder</th>
                <!-- <th>Send</th> -->
                <th>Remove Reminder</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(user, i) in users">
                <tr :key="i" :class="{ grey: i % 2 }">
                  <td data-label="Select All">
                    <input
                      :value="user"
                      v-model="selected_users"
                      type="checkbox"
                    />
                  </td>
                  <td data-label="First Name">
                    {{ user.first_name }}
                  </td>
                  <td data-label="Last Name">
                    {{ user.last_name }}
                  </td>
                  <td data-label="Email">{{ user.email }}</td>
                  <td data-label="Phone Number">{{ user.phone }}</td>
                  <td data-label="Department" :key="user.id">
                    {{
                      user.department
                        ? department_names[user.department]
                        : "TBD"
                    }}
                  </td>
                    <td data-label="Location" :key="user.id">
                    {{
                      user.location
                        ? location_names[user.location]
                        : "TBD"
                    }}
                  </td>
                  <td data-label="View">
                    <div class="filters">
                      <div class="filter">
                        <label>Email</label>
                        <div class="switch-holder">
                          <switches
                            @input="saveDeliveryType(user)"
                            v-model="user.delivery_types.email"
                          ></switches>
                        </div>
                      </div>
                      <div class="filter">
                        <label>Phone</label>
                        <div class="switch-holder">
                          <switches
                            @input="saveDeliveryType(user)"
                            v-model="user.delivery_types.text"
                          ></switches>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td data-label="Edit">
                    <img
                      @click="initScheduledpopup(user)"
                      class="action clickable"
                      src="@/assets/img/edit.svg"
                    />
                  </td>
                  <!-- <td data-label="View">
                    <img
                      @click="selectUser(user)"
                      class="action clickable"
                      src="@/assets/img/send.svg"
                    />
                  </td> -->
                  <td data-label="Delete">
                    <img
                      @click="setClearScheduledReminders(user)"
                      class="action clickable"
                      src="@/assets/img/delete.svg"
                    />
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <!-- <div class="pages">
            <div class='action page active' >
              {{((pagination.current_page-1)*pagination.page_size)+1}}-{{pagination.current_page*pagination.page_size}} of {{usage[source+'s']}}
            </div>
          </div> -->
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage(1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage()"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
        </div>
      </div>
    </div>

    <popup @save-user-reminder="saveUserReminder"> </popup>
  </div>
</template>

<script>
import Popup from "@/components/Popup.vue";
import firebase from "firebase";
import Swal from "sweetalert2";
import axios from "axios";
import Switches from "vue-switches";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  components: {
    popup: Popup,
    Switches,
  },
  data() {
    return {
      source: "",
      send_email: false,
      send_text: false,
      forms: null,
      helper: false,
      showPopup: false,
      popupType: "email",
      form: null,
      selected_user: null,
      client: null,
      users: [],
      usage: {
        forms: 0,
        visitors: 0,
        employees: 0,
        locations: 0,
        departments: 0,
      },
      locations: [],
      departments: [],
      department_names: {},
      location_names: {},
      delivery_types: [],
      unfilteredUsers: [],
      filter_values: {},
      locations: null,
      loading: false,
      selected_dates: [],
      reoccurrence_type: null,
      //   showClearBtn: false,
      showBulkBtn: false,
      selected_location: null,
      selected_department: null,
      selected_users: [],
      sendText: functions.httpsCallable("sendText"),
      sendEmail: functions.httpsCallable("sendEmail"),
      getEmailLink: functions.httpsCallable("getEmailLink"),
      importCSV: functions.httpsCallable("importCSV"),
      exportCSV: functions.httpsCallable("exportCSV"),
      importLoading: false,
      pagination: {
        previous_doc: null,
        next_doc: null,
        page_size: 10,
        current_page: 1,
      },
    };
  },
  mounted() {},
  async created() {
    this.source = this.$route.path
      .replace("/scheduled-reminders/", "")
      .slice(0, -1);
    return this.moveToPage(0);
  },
  firestore() {
    return {
      client: db.collection("user").doc(this.user_doc.id),
      locations: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("locations")
        .orderBy('name', 'asc'),
      departments: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("departments"),
      usage: db.collection("usage").doc(this.user_doc.id),
      unfilteredUsers: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("employee"),
      forms: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("forms"),
    };
  },
  watch: {
    departments() {
      this.departments.forEach((d) => {
        this.department_names[d.id] = d.name;
      });
    },
    locations() {
      this.locations.forEach((d) => {
        this.location_names[d.id] = d.name;
      });
    },
    selected_dates() {
      let days = {
        "00": false,
        "01": false,
        "02": false,
        "03": false,
        "04": false,
        "05": false,
        "06": false,
      };
      this.selected_dates.forEach((day) => {
        days[day] = true;
      });

      this.selected_users.forEach((user) => {
        user.reminders = days;
      });
    },
    reoccurrence_type() {
      this.selected_users.forEach((user) => {
        if (this.reoccurrence_type == "Every day") {
          user.reminders = {
            "00": true,
            "01": true,
            "02": true,
            "03": true,
            "04": true,
            "05": true,
            "06": true,
          };
        } else if (this.reoccurrence_type == "Every weekday") {
          user.reminders = {
            "00": true,
            "01": true,
            "02": true,
            "03": true,
            "04": true,
            "05": false,
            "06": false,
          };
        }
      });
    },
    showPopup() {
      if (!this.showPopup) {
        this.selected_users = [];
      }
    },
  },
  computed: {
    showClearBtn() {
      return !!Object.keys(this.filter_values).length;
    },
    userURL() {
      if (this.selected_user && this.form) {
        return `https://covidsurvey.web.app/${this.user_doc.id}/${this.form.id}/${this.selected_user.id}`;
      } else {
        return null;
      }
    },
    button_valid() {
      this.delivery_types = [];
      if (this.send_email) this.delivery_types.push("email");
      if (this.send_text) this.delivery_types.push("phone");
      if (this.delivery_types.length) {
        return {};
      } else {
        return { opacity: "30%", "pointer-events": "none" };
      }
    },
  },
  methods: {
    setClearScheduledReminders(user) {
      this.selected_users.push(user);
      this.clearScheduledReminders();
    },
    clearScheduledReminders() {
      Swal.fire({
        title: "Are you sure?",
        text: "You can always set a reminder at anytime",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "REMOVE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          let batch = db.batch();
          let promised_arr = this.selected_users.map((user) => {
            user.init_reminders = false;
            user.form_id = null;
            user.delivery_types = {
              email: false,
              text: false,
            };

            let ref = db
              .collection(`user/${this.user_doc.id}/${this.source}`)
              .doc(user.id);
            return batch.set(ref, user, { merge: true });
          });

          this.selected_users = [];
          this.selected_dates = [];
          this.reoccurrence_type = null;
          this.popupType = null;
          this.showPopup = false;
          this.form = null;
          this.$refs.selectAll.checked = false;
          return Promise.all([batch.commit(), ...promised_arr]);
        }
      });
    },
    clearAllScheduledReminders(){
      Swal.fire({
          title: "Are you sure?",
          text: "You can always set a reminder at anytime",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "REMOVE",
          cancelButtonText: "CANCEL",
        }).then(async (result) => {
          if (result.value) {
             let loader = this.$loading.show({
                                container: null,
                                canCancel: false,
                              });
            let batch = db.batch();
            let users = await db
                        .collection("user")
                        .doc(this.user_doc.id)
                        .collection(this.source)
                        .where("init_reminders", "==", true).get()

             let promised_arr = users.docs.map((doc) => {
             let ref = doc.ref
             let user = doc.data()
              user.init_reminders = false;
              user.form_id = null;
              user.delivery_types = {
                email: false,
                text: false,
              };
              return batch.set(ref, user, { merge: true });
            });
            loader.hide()
            this.reoccurrence_type = null;
            this.popupType = null;
            this.showPopup = false;
            this.form = null;
            this.$refs.selectAll.checked = false;
            return Promise.all([batch.commit(), ...promised_arr]).then(() => {
              return Swal.fire('', 'All reminders have been removed', 'info')
            });
          }
        });
    },
    moveToPage(page) {
      let pagination = this.pagination;
      let ref = db
        .collection("user")
        .doc(this.user_doc.id)
        .collection(this.source)
        .where("init_reminders", "==", true);

      for (const key in this.filter_values) {
        if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
          const element = this.filter_values[key];
          if (element) {
            ref = ref.where(`${key}`, "==", element);
          }
        }
      }
      if (page === -1) {
        //Previous Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("last_name", "desc")
          .startAfter(pagination.previous_doc);
      } else if (page === 1) {
        //Next Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("last_name")
          .startAfter(pagination.next_doc);
      } else if (page === 0) {
        //First page
        ref = ref.limit(pagination.page_size).orderBy("last_name");
      } else {
        //Last page
        let total = this.usage[this.source + "s"];
        let last_full_page = Math.floor(total / pagination.page_size);
        let limit = total - last_full_page * pagination.page_size;
        ref = ref
          .limit(limit || pagination.page_size)
          .orderBy("last_name", "desc");
      }

      ref.onSnapshot((query) => {
        let docs = query.docs;

        if (page === -1 || page === undefined) {
          // counting down
          docs.reverse();
        }
        if (query.size === 0 && page !== 0) {
          if (page === 1) {
            this.pagination.next_doc = null;
          } else if (page === -1) {
            this.pagination.previous_doc = null;
          }
        } else {
          let users = docs.map((d) => Object.assign({ id: d.id }, d.data()));
          this.pagination.previous_doc = docs[0];
          this.pagination.next_doc = docs[docs.length - 1];
          if (page === 0) {
            this.pagination.previous_doc = null;
            this.pagination.current_page = 1;
            if (query.size < pagination.page_size) {
              this.pagination.next_doc = null;
            }
          } else if (page === undefined) {
            let total = this.usage[this.source + "s"];
            let last_full_page = Math.ceil(total / pagination.page_size);
            this.pagination.next_doc = null;
            this.pagination.current_page = last_full_page;
          } else {
            this.pagination.current_page += page;
            if (query.size < pagination.page_size) {
              this.pagination[page === -1 ? "previous_doc" : "next_doc"] = null;
            }
          }
          this.users = users;
        }
        this.pagination = Object.assign({}, this.pagination);
      });
      return true;
    },
    saveUserReminder() {
      let batch = db.batch();
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      let promised_arr = this.selected_users.map((user) => {
        user.init_reminders = true;
        user.form_id = this.form.id;

        let ref = db
          .collection(`user/${this.user_doc.id}/${this.source}`)
          .doc(user.id);
        return batch.set(ref, user, { merge: true });
      });

      return Promise.all([batch.commit(), ...promised_arr]).then(() => {
        this.selected_users = [];
        this.selected_dates = [];
        this.reoccurrence_type = null;
        this.popupType = null;
        this.showPopup = false;
        this.form = null;
        loader.hide();
      });
    },
    saveDeliveryType(user) {
      let ref = db
        .collection(`user/${this.user_doc.id}/${this.source}`)
        .doc(user.id);

      return ref.set(user, { merge: true });
    },
    /*filter() {
      this.showBulkBtn = true;
      this.showClearBtn = true;

      if (this.filter_values.location && this.filter_values.department) {
        this.users = this.unfilteredUsers.filter(
          (user) =>
            user.location &&
            user.department &&
            user.department.id == this.filter_values.department.id &&
            user.location.id == this.filter_values.location.id
        );
      } else {
        for (let key in this.filter_values) {
          this.users = this.unfilteredUsers.filter(
            (user) => user[key] && user[key].id == this.filter_values[key].id
          );
        }
      }
    },*/
    clearFilter() {
      this.showBulkBtn = false;
      this.users = this.unfilteredUsers;
      this.filter_values = {};
      this.moveToPage(0);
    },
    initBulkPopup() {
      this.showPopup = true;
      this.popupType = "bulk";
    },
    initScheduledpopup(user) {
      if (user) {
        this.selected_users.push(user);
      }
      this.showPopup = true;
      this.popupType = "scheduled";
    },
    selectAll(e) {
      if (e.target.checked) {
        this.selected_users = this.users;
      } else {
        this.selected_users = [];
      }
    },
    activate(item) {
      if (this.details == item.sku) {
        this.details = null;
      } else {
        this.details = item.sku;
      }
    },

    selectUser(user) {
      this.checkLogo(user);
    },
    checkLogo(user) {
      if (this.client.logo) {
        this.checkLocations(user);
      } else {
        return Swal.fire("Please add a company logo first!").then(() =>
          this.$router.push({ path: "/profile" })
        );
      }
    },
    checkLocations(user) {
      if (this.locations.length) {
        this.selected_user = user;
        this.popupType = "email";
        this.showPopup = true;
      } else {
        return Swal.fire("Last Step! Please add a location first.").then(() =>
          this.$router.push({ path: "/locations" })
        );
      }
    },

    showImportPopup() {
      this.popupType = "import";
      this.showPopup = true;
    },
  },
};
</script>

<style scoped lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}

.title {
  font-size: 30px;
  font-weight: bold;
  font-family: "SFProDisplay", sans-serif;
  margin-top: 0;
  line-height: 1.2;
}

.full .v-select {
  max-width: 100%;
}

.holder .btn {
  margin-top: 20px;
}

.full {
  width: 100%;
}

.loader {
  height: 100px;
}

td .filters {
  flex-wrap: nowrap;
}
</style>
